import { AllCompaniesQueryResponse } from '../../../types/api/endpoints/companies/allCompany.types';
import { COMPANY_ENDPOINTS } from '../../../utils/api/endpoints/companyEndpoints';
import { ConfirmedCompaniesQueryParams } from './useConfirmedCompanies.types';

const PREFIX = '[allCompaniesQuery]';

export const queryConfirmedCompanies = async (params: ConfirmedCompaniesQueryParams) => {
  console.log(PREFIX, `Fetching all companies...`);
  const response = await COMPANY_ENDPOINTS.getConfirmed(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received all companies.`);
  return json as AllCompaniesQueryResponse;
};
